var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('v-progress-linear',{staticClass:"theme--light",attrs:{"indeterminate":"","absolute":"","height":"2","color":"secondary lighten-2","aria-label":"Progress Bar"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }